import React, { FunctionComponent } from 'react'
import Slider from 'react-slick'
import { useSlickReady } from '../../../hooks/useSlickReady'
import type { CompanyData } from '../../../types/eventDetail';
import type { CompanyIndustry } from '../../../types/eventDetail'

type Props = {
  company: CompanyData
  noImage: string
}

export const Presentation: FunctionComponent<Props> = ({ company, noImage }) => {
  const ready = useSlickReady(company.company_people?.length > 0)
  const width = window.innerWidth;
  const initialSlides = width <= 781 ? 2 : width <= 1025 ? 3 : 5;
  const sliderSettings = {
    infinite: true,
    slidesToShow: initialSlides,
    slidesToScroll: initialSlides,
    arrows: true,
    dots: false,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          dots: false,
          arrows: true
        }
      },
      {
        breakpoint: 781,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          dots: false,
          arrows: true
        }
      }
    ]
  }

  return (
    <>
      <div className='article-bgimg article-bgimg-secondly'>
        <img
          src={company.cover_image || noImage}
          alt='企業のカバー写真'
        />
      </div>

      <section className='article-section article-section-company' id='article-03'>
        <div className='article-section-info'>会社について</div>

        {company.company_people?.length ? (
          <>
            <h2 className='article-section-heading'>メンバー</h2>
            <div className='article-section-description'>
              {ready &&
                <Slider {...sliderSettings} className='article-section-member'>
                  {company.company_people.map((cp: {
                    person_id: number;
                    position: string;
                    person?: {
                      icon?: string;
                      full_name?: string;
                    };
                  }) => (
                    <li className='article-section-member-list' key={cp.person_id}>
                      <a
                        href={`/company_people/${cp.person_id}`}
                        className='article-section-member-link'
                        data-event='click'
                        data-category='eventcontent'
                        data-value='company_people_link'
                      >
                        <div className='article-section-member-img-box'>
                          <img
                            className='article-section-member-img'
                            src={cp.person?.icon || noImage}
                            alt='プロフィール写真'
                          />
                        </div>
                        <p className='article-section-member-name'>
                          {cp.person?.full_name}
                        </p>
                        <p className='article-section-member-position'>
                          {cp.position}
                        </p>
                      </a>
                    </li>
                  ))}
                </Slider>
              }
            </div>
          </>
        ) : null}

        {(company.profile.information_title ||
          company.profile.information_description ||
          company.profile.information_image_1?.url ||
          company.profile.information_image_2?.url) && (
          <>
            <div className='article-section-heading'>
              何をやっているのか/独自のサービス
            </div>

            {company.profile.information_title && (
              <h2 className='article-section-title'>
                {company.profile.information_title}
              </h2>
            )}

            {(company.profile.information_image_1?.url || company.profile.information_image_2?.url) && (
              <div className='article-section-gallery'>
                <ul className='article-section-gallery-inner u-clear'>
                  {company.profile.information_image_1?.url && (
                    <li className='article-section-gallery-item'>
                      <div className='article-section-gallery-wrap' style={{ width: '100%' }}>
                        <div className='article-section-gallery-content'>
                          <div
                            className='article-section-gallery-img'
                            style={{
                              backgroundImage: `url(${company.profile.information_image_1.url})`
                            }}
                          ></div>
                        </div>
                      </div>
                      {company.profile.information_image_1_description && (
                        <p className='article-section-gallery-text' style={{ width: '100%' }}>
                          {company.profile.information_image_1_description}
                        </p>
                      )}
                    </li>
                  )}

                  {company.profile.information_image_2?.url && (
                    <li className='article-section-gallery-item'>
                      <div className='article-section-gallery-wrap' style={{ width: '100%' }}>
                        <div className='article-section-gallery-content'>
                          <div
                            className='article-section-gallery-img'
                            style={{
                              backgroundImage: `url(${company.profile.information_image_2.url})`
                            }}
                          ></div>
                        </div>
                      </div>
                      {company.profile.information_image_2_description && (
                        <p className='article-section-gallery-text' style={{ width: '100%' }}>
                          {company.profile.information_image_2_description}
                        </p>
                      )}
                    </li>
                  )}
                </ul>
              </div>
            )}

            {company.profile.information_description && (
              <div
                className='article-section-description'
                dangerouslySetInnerHTML={{
                  __html: company.profile.information_description.replace(/\r?\n/g, '<br>')
                }}
              />
            )}
          </>
        )}

        {(company.profile.mission_title ||
          company.profile.mission_description ||
          company.profile.mission_image_1?.url ||
          company.profile.mission_image_2?.url) && (
          <>
            <div className='article-section-heading'>企業の役割（企業理念）</div>

            {company.profile.mission_title && (
              <h2 className='article-section-title'>
                {company.profile.mission_title}
              </h2>
            )}

            {(company.profile.mission_image_1?.url ||
              company.profile.mission_image_2?.url) && (
              <div className='article-section-gallery'>
                <ul className='article-section-gallery-inner u-clear'>
                  {company.profile.mission_image_1?.url && (
                    <li className='article-section-gallery-item'>
                      <div className='article-section-gallery-wrap' style={{ width: '100%' }}>
                        <div className='article-section-gallery-content'>
                          <div
                            className='article-section-gallery-img'
                            style={{
                              backgroundImage: `url(${company.profile.mission_image_1.url})`
                            }}
                          />
                        </div>
                      </div>
                      {company.profile.mission_image_1_description && (
                        <p className='article-section-gallery-text' style={{ width: '100%' }}>
                          {company.profile.mission_image_1_description}
                        </p>
                      )}
                    </li>
                  )}

                  {company.profile.mission_image_2?.url && (
                    <li className='article-section-gallery-item'>
                      <div className='article-section-gallery-wrap' style={{ width: '100%' }}>
                        <div className='article-section-gallery-content'>
                          <div
                            className='article-section-gallery-img'
                            style={{
                              backgroundImage: `url(${company.profile.mission_image_2.url})`
                            }}
                          />
                        </div>
                      </div>
                      {company.profile.mission_image_2_description && (
                        <p className='article-section-gallery-text' style={{ width: '100%' }}>
                          {company.profile.mission_image_2_description}
                        </p>
                      )}
                    </li>
                  )}
                </ul>
              </div>
            )}

            {company.profile.mission_description && (
              <div className='article-section-description'>
                {company.profile.mission_description
                  .split('\n')
                  .map((line, i) => (
                    <p key={i}>{line}</p>
                  ))}
              </div>
            )}
          </>
        )}

        <table className='article-section-table'>
          <thead className='article-section-table-heading'>
            <tr>
              <th colSpan={2}>会社情報</th>
            </tr>
          </thead>
          <tbody className='article-section-table-body'>
            <tr className='article-section-table-line'>
              <td className='article-section-table-category'>
                会社・団体名
              </td>
              <td className='article-section-table-content'>{company.name}</td>
            </tr>
            <tr>
              <td className='article-section-table-category'>
                資本金
              </td>
              <td className='article-section-table-content'>
                {company.profile.shihonkin}
              </td>
            </tr>
            <tr>
              <td className='article-section-table-category'>
                設立年月
              </td>
              <td className='article-section-table-content'>
                {company.profile.setsuritsunengetsu}
              </td>
            </tr>
            <tr>
              <td className='article-section-table-category'>
                代表者氏名
              </td>
              <td className='article-section-table-content'>
                {company.profile.daihyoshaname}
              </td>
            </tr>
            <tr>
              <td className='article-section-table-category'>
                従業員数
              </td>
              <td className='article-section-table-content'>
                {company.profile.jugyoinsu}
              </td>
            </tr>
            <tr>
              <td className='article-section-table-category'>
                本社所在地
              </td>
              <td className='article-section-table-content'>
                {company.profile.honshashozaichi}
              </td>
            </tr>
            <tr>
              <td className='article-section-table-category'>
                業種
              </td>
              <td className='article-section-table-content'>
                {company.company_industries?.map((companyIndustry: CompanyIndustry, index: number) => (
                  <React.Fragment key={companyIndustry.industry.to_en}>
                    <a
                      href={`/companies/${companyIndustry.industry.to_en}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {companyIndustry.industry.name}
                    </a>
                    {(company.company_industries && index < company.company_industries.length - 1) && ' / '}
                  </React.Fragment>
                ))}
              </td>
            </tr>
          </tbody>
        </table>
      </section>
    </>
  )
}
